import { Inject, Injectable } from "@angular/core";
import { IWelcomeWizardModalService, WelcomeWizardInitialState } from "./i-welcome-wizard-modal.service";
import { IModalService, modalServiceInjectionToken } from "@zaeper/angular-dashboard-view-lib";
import { WelcomeWizardModalComponent } from "./welcome-wizard-modal.component";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Injectable()
export class WelcomeWizardModalService implements IWelcomeWizardModalService {
	constructor(@Inject(modalServiceInjectionToken) private readonly _modalService: IModalService) {
	}

	open(initialState: WelcomeWizardInitialState = "choose"): DynamicDialogRef {
		return this._modalService.open(WelcomeWizardModalComponent, {
			showHeader: false,
			closable: false,
			width: "640px",
			closeOnEscape: false,
			dismissableMask: false,
			styleClass: "welcome-wizard-modal",
			data: { initialState }
		});
	}
}
